module.exports = __webpack_public_path__ + "img/device_dr002.c1515f31.png";